export const UPDATE_USER = 'UPDATE_USER';

export const GET_USER_BY_TOKEN = 'GET_USER_BY_TOKEN'
export const GET_USER_BY_TOKEN_FAILED = 'GET_USER_BY_TOKEN_FAILED'
export const GET_USER_BY_TOKEN_OK = 'GET_USER_BY_TOKEN_OK'

import getUserByToken from 'controllers/user/getUserByToken'

// import { getSubscription } from './subscription';

export function fetchUserByToken() {
  return function(dispatch) {

    getUserByToken().then(function(result) {

      let rolesPerSchool = {}
      if(result.data.school_list){
        result.data.school_list.map((school) => {
          if (school.role_group[0]) {
            rolesPerSchool[school.school_id] = {
              role: school.role_group[0].name,
              permissions: school.permissions,
            }
          }
        })
      }

      dispatch({
        type: GET_USER_BY_TOKEN_OK,
        result: result.data,
        rolesPerSchool,
      });

      // dispatch(getSubscription());

    }).catch(function (error) {
      console.error(error);

      dispatch({
        type: GET_USER_BY_TOKEN_FAILED,
        error,
      });
    });
  }
}

const initState = {
  result: {
    school_list: [],
    teacher_to_be_confirmed: [],
  },
  rolesPerSchool: {},
  loading: true,
  loginRequired: false,
  loaded: false,
  login: false,
}

export default function user(state = initState, action) {
  switch(action.type){
    case UPDATE_USER: {
      const {
        user,
      } = action;
      return {
        ...state,
        user,
      }
    }

    case GET_USER_BY_TOKEN: {
      return { ...state, loading: true, }
    }
    case GET_USER_BY_TOKEN_OK: {
      let { result, rolesPerSchool } = action
      if (state.error) {
        delete state.error
      }

      return {
        ...state,
        result,
        rolesPerSchool,
        loading: false,
        loaded: true,
        login: true,
        loginRequired: false,
      }
    }
    case GET_USER_BY_TOKEN_FAILED: {
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: true,
        login: false,
        loginRequired: true,
      }
    }

    default: return {...state}

  }

}



// WEBPACK FOOTER //
// ./src/containers/Main/ducks/user.js